<template>
  <div style="min-height: 100%;position: relative;background-color:#f6f6f6;font-size: '苹方'">
    <div style="width: 100%; background-color:#f6f6f6;height: 120px;">
      <HomeHeader></HomeHeader>
    </div>
    <div style="background-color: #f6f6f6;padding-bottom: 170px;">
      <div class="body-content" style="width: 1180px;margin: auto;background-color: #f6f6f6;">
        <div class="frame-content">
          <div class="count_down_box">
            <i class="el-icon-timer" />
            <span>请在{{countdownMinute}}分{{countdownSecond}}秒内完成支付, 以免房间被订或者价格发生变化</span>
          </div>
          <div class="info-content" style="width: 1180px;margin: auto;">
            <div style="padding: 20px 40px;">
<!--              <div class="form-title" style="font-weight: 600;margin-bottom: 25px;font-size: 20px;font-weight: '苹方" v-if="orderInfo.hotelName">-->
<!--                {{ getHotelName(orderInfo.hotelName, 0) }}-->
<!--                <span>-->
<!--                  {{ getHotelName(orderInfo.hotelName, 1) }}-->
<!--                </span>-->
<!--              </div>-->
              <div class="form-val">
                <span style="font-size: 16px;font-weight: bold">{{ orderInfo.priRoomtype }}</span>
                <span v-if="orderInfo.priRoomtypeEn" style="font-size: 13px;color: #a2a9b4">- {{ orderInfo.priRoomtypeEn }}</span>
              </div>
              <div style="display: flex;">
                <span style="color: #5e6f88;display: flex;align-items: center;column-gap: 5px">
                  <i class="iconfont icon-a-qietu1" />{{ orderInfo.priBedtype }}
                </span>
                <span style="margin-left: 10px;color: #5e6f88;display: flex;align-items: center;column-gap: 5px">
                  <i class="iconfont icon-fangzi222" style="font-size: 18px"/>{{ searchForm.room }}间
                </span>
              </div>
              <div class="form-val" v-if="bookingRates" style="margin-top: 15px">
                <i class="iconfont icon-rili" style="color: #60718a !important;"/>
                {{ orderInfo.checkIn }} {{ $t('booking.to') }} {{ orderInfo.checkOut }}&nbsp;&nbsp;
                共 {{ bookingRates.length }} {{ $t('search.night') }}
              </div>
              <div class="form-val">
                <span class="form-val" v-if="orderInfo.canCancel == 'yes'"
                      style="color: #26b38f;background-color: #e6f7e6;padding: 2px 8px;border-radius: 4px">
                    <i class="el-icon-circle-check" style="color: #82bf23"/>
                        <span v-if="isLang">{{ $t('hotel_detail.Free_cancellation_before') }} {{orderInfo.b2bCancel }}</span>
                        <span v-else>{{ orderInfo.b2bCancel }} {{ $t('hotel_detail.Free_cancellation_before') }}</span>
                      </span>
                <span class="form-val" style="color: #c20000" v-else>
                        {{ $t('hotel_detail.no_cancel') }}
                      </span>
              </div>
            </div>

            <div
              style="padding: 30px 40px; text-align: right;border-top: 1px solid #ECECEC;display: flex;align-items: center;justify-content: space-between;">
              <span style="font-size: 14px;color: #898989;">{{ $t('cashier.Total_order_amount') }}</span>
              <span style="font-size: 18px; color: #ff7b77;font-weight: 600;">
                ￥{{ orderInfo.payAmount }}
              </span>
            </div>
          </div>


          <div class="info-content" style="width: 1180px;margin: auto;margin-top: 20px;">
            <div style="padding: 0 40px">
              <div class="form-title" style="font-weight: bold;font-size: 18px;margin-top: 30px;">支付方式</div>
              <div class="pay-tab-content">
                <div style="text-align:left;width: 30%" @click="payActive(1)" class="pay-tab-content_div credit_box"
                     :class="menuIndex === 1 ? 'isPayActive' : ''"
                     v-if="settleWay === 0 && (partnerInfo.personType === 1 || (partnerInfo.personType === 2 && $commonUtil.getAccountPermission('allowCredit')))">
                  <div>
                    <i class="iconfont icon-danxuanweixuanzhong_o" style="font-size: 20px" v-if="menuIndex !== 1"/>
                    <i class="iconfont icon-xuanzhong" style="color: #0066cc;font-size: 20px" v-if="menuIndex === 1"/>
                  </div>
                  <div style="display: flex;align-items: center;column-gap: 15px;">
                    <img src="@/assets/img/图层-1.png"
                         style="width: 20px; height: 20px; margin-top: 0;" />
                    <div style="font-size:18px;" class="credit_limit">
                      <p style="font-size: 14px;color: #000000;font-weight: 600">
                        {{ $t('cashier.Credit_limit') }}
                      </p>
                      <p>
                      <span style="color: #898989;font-size: 14px;">
                        {{ $t('cashier.Current_available_credit') }}:
                      </span>
                        <span style="color: #1e50f0;margin-left: 6px;font-size: 14px">
                        CNY {{ creditAmount / 100 }}{{ $t('booking.yuan') }}
                      </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div style="font-size: 22px;text-align: left;width: 30%" @click="payActive(2)"
                     class="pay-tab-content_div" :class="menuIndex === 2 ? 'isPayActive' : ''">
                  <div>
                    <i class="iconfont icon-danxuanweixuanzhong_o" style="font-size: 20px" v-if="menuIndex !== 2"/>
                    <i class="iconfont icon-xuanzhong" style="color: #0066cc;font-size: 20px" v-if="menuIndex === 2"/>
                  </div>
                  <div>
                    <img src="@/assets/img/图层 47.png" style="width: 20px;height: 20px;" />
                    <span style="font-size: 14px;margin-left: 10px;font-weight: 600">{{ $t('cashier.Alipay') }}</span>
                  </div>
                </div>
                <div style="text-align: left;display: flex;align-items: center;width: 30%" class="pay-tab-content_div"
                     @click="payActive(3)" :class="menuIndex === 3 ? 'isPayActive' : ''">
                  <div>
                    <i class="iconfont icon-danxuanweixuanzhong_o" style="font-size: 20px" v-if="menuIndex !== 3"/>
                    <i class="iconfont icon-xuanzhong" style="color: #0066cc;font-size: 20px" v-if="menuIndex === 3"/>
                  </div>
                  <div>
                    <i class="iconfont icon-weixinzhifu" style="color: #24b340;font-size: 20px"/>
                    <span style="font-size: 14px;margin-left: 10px;font-weight: 600">微信支付</span>
                  </div>
                </div>
              </div>
              <el-button class="payBtn" @click="submit">
                {{ $t('cashier.Immediate_payment') }}&nbsp;&nbsp;CNY {{ orderInfo.payAmount }}
              </el-button>
            </div>
          </div>

          <!--   立即支付按钮     -->
          <div style="width: 1180px;margin-top: 30px;padding-bottom: 130px;">
          </div>
        </div>
      </div>
    </div>


    <!--   底部   -->
    <div style="width: 100%;  background-color:#fff;position: absolute;bottom: 0;">
      <ContantUs></ContantUs>
      <footerInfo />
    </div>

    <div class="retrun-dialog">
      <el-dialog :visible.sync="isShowReturn" :show-close="false" :center="true" :close-on-click-modal="false"
        :close-on-press-escape="false" width="500px">
        <div style="text-align: center; font-size: 18px">
          <div v-if="resultCode == $finalData.B2BAPIResultCode_InsufficientAmount">
            信用额度不足，请更换支付方式或充值后重新预订。
          </div>
          <div v-else-if="resultCode == $finalData.B2BAPIResultCode_NoRoom">
            无房或满房，请重新预订。
          </div>
          <div v-else>下单失败，请重新预订。</div>
          <div class="btn-normal">
            <el-button type="primary" @click="toHotelList" style="margin-top: 30px; width: 100%">
              确定
            </el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <WXPayDialog ref="wxPayDialog"/>
  </div>
</template>

<script>
import HomeHeader from './components/HomeHeader.vue';
import ContantUs from './components/ContantUs.vue';
import footerInfo from '../frame/footerInfo.vue';
import WXPayDialog from './components/WXPayDialog.vue'

export default {
  components: {
    HomeHeader,
    ContantUs,
    footerInfo,
    WXPayDialog
  },
  data () {
    return {
      menuIndex: 1,
      menuList: [
        { id: 1, name: this.$t('cashier.Credit_limit'), img: require('@/assets/img/cashier_credit.png') },
        { id: 2, name: this.$t('cashier.Alipay'), img: require('@/assets/img/cashier_alipay.png') }
      ],
      orderInfo: {},
      isShowReturn: false,
      resultCode: 0,
      searchForm: {},
      bookingRates: [],
      creditAmount: 0,
      countdownTime: 15 * 60,
      countdownMinute: 0,
      countdownSecond: 0,
      isStopTime: 0,
      settleWay: 0,
      partnerInfo: {}
    }
  },
  mounted () {
    this.init()
    this.$commonUtil.modfiyicon()
  },
  methods: {
    async init () {
      this.partnerInfo = JSON.parse(localStorage.getItem('partnerInfo'))
      this.settleWay = this.partnerInfo.settleWay
      if (this.settleWay !== 0) {
        this.menuIndex = 2
      } else {
        if (this.partnerInfo.personType === 2) {
          if (this.$commonUtil.getAccountPermission("allowCredit")) {
            this.menuIndex = 1
          } else {
            this.menuIndex = 2
          }
        } else {
          this.menuIndex = 1
        }
      }
      let outerId = this.$route.query.outerId
      let orderTime = this.$route.query.orderTime
      if (orderTime) {
        let currTime = Date.now() / 1000
        let bookTime = new Date(orderTime).getTime() / 1000
        this.countdownTime = (15 * 60) - (currTime - bookTime)
      }
      await this.getPayInfo(outerId)
      // if (localStorage.getItem(`bookingOrderInfo-${outerId}`)) {
      //   this.orderInfo = JSON.parse(localStorage.getItem(`bookingOrderInfo-${outerId}`))
      //   this.searchForm = JSON.parse(localStorage.getItem(`bookingSearchForm-${outerId}`))
      //   this.bookingRates = JSON.parse(localStorage.getItem(`bookingRates-${outerId}`))
      // } else {
      //
      // }
      let vm = this
      let headersReq = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
      }
      vm.$http.get('/mini/currentCredit', { headers: headersReq }).then(resp => {
        let result = resp.body
        if (result.code == 200) {
          vm.creditAmount = result.data
        } else {
          vm.creditAmount = 0
        }
      }).catch(resp => {
        vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
      }).finally(() => { })
      vm.countdown()
    },
    async getPayInfo (outerId) {
      let headersReq = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token,
        outerId
      }
      const {data: result} = await this.$http.get('/mini/getPayInfo', {headers: headersReq})
      if (result.code !== 200) {
        await this.$router.push('/NewHome')
        return
      }
      let payInfo = JSON.parse(result.data)
      this.orderInfo = payInfo.bookingOrderInfo
      this.searchForm = payInfo.bookingSearchForm
      this.bookingRates = payInfo.bookingRates
    },
    submit () {
      this.isStopTime = 1
      localStorage.removeItem('bookingOrderInfo')
      let vm = this
      if (this.menuIndex == 1) {
        let loading2 = this.$loading({
          // lock: true,
          text: '努力加载中，请稍后.....',
          spinner: 'el-icon-loading',
          background: this.$finalData.LoadingBgColorAll
        })
        let reqHeader = {
          accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
        }
        vm.$http.get(`/mini/creditPay?outerOrderId=${vm.orderInfo.outerOrderId}`, { headers: reqHeader }).then(resp => {
          let result = resp.data
          if (result.code != 200) {
            vm.resultCode = result.resultCode
            vm.isShowReturn = true
            return
          } else {
            vm.$message.success('下单成功！')
            vm.$router.push('/orderManage/OrderList')
          }
        }).catch(resp => {
          vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
        }).finally(() => {
          loading2.close()
        })
      } else if (this.menuIndex == 2) {
        if (!vm.orderInfo.payAmount) {
          vm.$message.warning('连接超时，请重新下单')
          vm.$router.push('/NewHome')
          return
        }
        let aliReq = {
          // orderId: vm.orderInfo.orderId,
          partnerCode: vm.$commonUtil.getPartnerInfo().partnerCode,
          outerOrderId: vm.orderInfo.outerOrderId,
          amount: vm.orderInfo.payAmount,
          title: vm.getHotelName(vm.orderInfo.hotelName, 0)
        }
        vm.$http.get('/b2b/web/alipayPagePay', { params: aliReq }).then(resp => {
          let pageDiv = document.createElement('div')
          pageDiv.innerHTML = resp.body
          document.body.appendChild(pageDiv)
          document.forms[0].submit()
        }).catch(resp => {
          vm.$message.error('Error：' + resp.status + ' - ' + resp.statusText)
        }).finally(() => {
        })
      } else if (this.menuIndex == 3) {
        this.showQrcode()
      }
    },
    async showQrcode () {
      let reqHeader = {
        accessToken: JSON.parse(localStorage.getItem('partnerInfo')).token
      }
      let expireTime = new Date(Date.now() + 900000).Format('yyyy-MM-ddTHH:mm:ss');
      let payReq = {
        orderNumber: this.orderInfo.outerOrderId,
        expireTime
      }
      const {data: result} = await this.$http.post('/b2b/web/wxNativePay', payReq, {headers: reqHeader})
      if (result.code !== 200) return this.$message.error(result.message)
      if (result.data.code_url) {
        this.$refs['wxPayDialog'].init(result.data.code_url, this.orderInfo.payAmount, this.orderInfo.outerOrderId)
      }
    },
    toOrder () {
      console.log('toOrder')
    },
    toHotelList () {
      if (this.resultCode == this.$finalData.B2BAPIResultCode_InsufficientAmount) {
        this.isShowReturn = false
        return
      }
      this.$router.push({
        path: '/bookingDetail',
        query: this.searchForm
      })
    },
    formatCancelTime (cancellationPolicy) {
      if (cancellationPolicy) {
        let index = cancellationPolicy.lastIndexOf('|')
        if (index == -1) {
          return ''
        }
        if (cancellationPolicy.length < 3) {
          return ''
        }
        let resStr = cancellationPolicy.substring(index + 1, cancellationPolicy.length - 3)
        resStr = resStr.replace('T', ' ')
        return resStr
      }
      return ''
    },
    getHotelName (hotelName, index) {
      if (hotelName) {
        let words = hotelName.split('-')
        if (words.length > index) {
          return words[index]
        }
      }
      return '酒店'
    },
    countdown () {
      if (this.countdownTime >= 0) {
        this.countdownMinute = Math.floor(this.countdownTime / 60)
        this.countdownSecond = Math.floor(this.countdownTime % 60)
        this.countdownTime--
        let vm = this
        window.setTimeout(() => {
          vm.countdown()
        }, 1000)
      } else if (this.isStopTime == 0) {
        this.closeOrder()
      }
    },
    closeOrder () {
      let vm = this
      vm.$http.get('/b2b/web/closeOrder', { params: { outerOrderId: vm.orderInfo.outerOrderId } }).then(resp => {
      }).catch(resp => {
        console.log('Error：' + resp.status + ' - ' + resp.statusText)
      }).finally(() => {
        vm.$message.warning('订单已超时关闭，请重新下单')
        vm.$router.push('/orderManage/OrderList')
      })
    },
    payActive (type) {
      this.menuIndex = type
    }
  },
  computed: {
    isLang () {
      return localStorage.getItem('lang') == 'en'
    }
  }
}
</script>

<style scoped>
.super-link {
  color: #144199;
  cursor: pointer;
  text-decoration: underline;
  font-weight: 600;
  font-size: 14px;
  margin-right: 20px;
}

.body-content {
  background-color: #ffffff;
  padding-bottom: 20px;
  text-align: center;
}

.info-content {
  background-color: #ffffff;
  margin-bottom: 25px;
  text-align: left;
  border: 1px solid #F3F3F3;
}

.form-title {
  font-weight: '苹方';
  font-size: 16px;
  margin-top: 30px;
}

.form-row {
  line-height: 30px;
  margin-bottom: 10px;
}

.form-name {
  font-weight: 400;
  font-size: 18px;
  color: #898989;
  width: 50px;
}

.form-val {
  font-size: 14px;
  color: #000000;
  font-family: '苹方';
  font-weight: 400;
  margin-bottom: 15px;
}

.form-line {
  padding-left: 10px;
  padding-right: 10px;
  color: #9d9d9d;
}

.pay-tab-title {
  border-top: 1px solid #dddddd;
  border-left: 1px solid #dddddd;
  border-right: 1px solid #dddddd;
  display: inline-block;
  width: 130px;
  height: 56px;
  line-height: 56px;
  text-align: center;
  cursor: pointer;
  margin-right: 10px;
}

.pay-tab-title-click {
  border-top: 1px solid #144199;
  border-left: 1px solid #144199;
  border-right: 1px solid #144199;
  border-bottom: 1px solid #fff;
}

.pay-tab-menu {
  margin-top: 30px;
}

.pay-tab-content {
  font-size: 10px;
  text-align: center;
  column-gap: 10px;
  margin-top: 35px;
  margin-bottom: 50px;
  display: flex;
  justify-content: space-between;
}

.retrun-dialog>>>.el-dialog {
  border-radius: 7px;
}

.retrun-dialog>>>.el-dialog__header {
  height: 0;
  padding: 0;
}

.retrun-dialog>>>.el-dialog__body {
  padding: 35px;
}

.pay-tab-content_div {
  border: 1px solid #F3F3F3;
  cursor: pointer;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  column-gap: 10px;
}

.pay-tab-content_div:hover {
  border: 1px solid #1e50f0;
}

.isPayActive {
  border: 1px solid #1e50f0;
}

.payBtn {
  width: 100%;
  background-color: #1e50f0;
  color: #ffffff;
  font-size: 22px;
  height: 55px;
  border: 0 solid #ffffff;
  margin-bottom: 25px;
}

.credit_box {
  display: grid;
  grid-template-columns: max-content 1fr;
  align-items: center;
  grid-column-gap: 10px;
}

.credit_limit {
  display: grid;
  grid-template-rows: repeat(2, auto);
  grid-row-gap: 10px;
}
</style>

<style lang="stylus" scoped>
.count_down_box {
  padding: 20px;
  background-color: #fde9e0;
  border-radius: 8px;
  box-shadow: 2px 2px 5px #ECECEC;

  color: #f67939;
  font-size: 14px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/booking/Cashier.vue